import { css } from '@emotion/react';

export function quoteResultsV2CSS() {
    return css`
        width: 100%;
        overflow: hidden;

        .ResultsOuter {
            overflow: hidden;
        }

        .ResultsInner {
            padding-top: 2.5rem;
        }

        .ResultsShell {
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, rgba(249, 255, 251, 0.75) 100%);
            border: 1px solid rgba(34, 236, 155, 0.25);
            border-radius: 20px;
            padding: 1.75rem 1.5rem;
            box-shadow: 0 10px 40px -20px rgba(34, 236, 155, 0.35),
                        0 4px 12px -6px rgba(0, 0, 0, 0.05);
            overflow: hidden;
            position: relative;
        }

        .ResultsHeader {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            justify-content: space-between;
            gap: 0.75rem;
            margin-bottom: 1.25rem;
            padding-bottom: 1rem;
            border-bottom: 1px dashed rgba(34, 236, 155, 0.35);
        }

        .ResultsHeader h2 {
            font-size: 1.35rem;
            font-weight: 700;
            margin: 0;
            color: #0f172a;
            letter-spacing: -0.02em;
        }

        .ResultsHeader .hint {
            font-size: 0.85rem;
            color: #6b7280;
        }

        .TablesGrid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 1.75rem;
        }

        @media (min-width: 960px) {
            .TablesGrid.two-col {
                grid-template-columns: 1.5fr 1fr;
                align-items: start;
            }
        }

        .MatrixHeader {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            gap: 0.75rem;
            margin-bottom: 0.9rem;
        }

        .MatrixTitle {
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .MatrixTitle h3 {
            font-size: 1rem;
            font-weight: 600;
            margin: 0;
            color: #0f172a;
            letter-spacing: -0.01em;
        }

        .MatrixTitle .Subtitle {
            color: #94a3b8;
            font-size: 0.8rem;
        }

        .MatrixTitle .Dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #22ec9b;
            box-shadow: 0 0 0 4px rgba(34, 236, 155, 0.18);
        }

        .MatrixTitle .Dot.amber {
            background: #32B8DF;
            box-shadow: 0 0 0 4px rgba(50, 184, 223, 0.2);
        }

        .ModeToggle {
            position: relative;
            display: inline-flex;
            background: #f1f5f9;
            border-radius: 999px;
            padding: 4px;
            font-size: 0.9rem;
        }

        .ModeToggle button {
            position: relative;
            z-index: 2;
            border: 0;
            background: transparent;
            padding: 0.45rem 1.1rem;
            border-radius: 999px;
            cursor: pointer;
            font-weight: 500;
            color: #475569;
            transition: color 0.25s;
            white-space: nowrap;
        }

        .ModeToggle button.active {
            color: #064e3b;
        }

        .ModeToggle .ToggleIndicator {
            position: absolute;
            top: 4px;
            left: 4px;
            width: calc(50% - 4px);
            height: calc(100% - 8px);
            background: #ffffff;
            border-radius: 999px;
            z-index: 1;
            box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
        }

        .MatrixScroll {
            overflow-x: auto;
            border-radius: 14px;
            border: 1px solid #eef2f7;
        }

        .MatrixTable {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.88rem;
        }

        .MatrixTable th,
        .MatrixTable td {
            padding: 0.65rem 0.85rem;
            text-align: right;
            white-space: nowrap;
        }

        .MatrixTable th.col-head {
            background: #f8fafc;
            color: #64748b;
            font-weight: 600;
            font-size: 0.78rem;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            border-bottom: 1px solid #e2e8f0;
        }

        .MatrixTable th.col-head.current-col {
            background: #ecfdf5;
            color: #065f46;
        }

        .MatrixTable td.plazo-cell.current-col {
            background: rgba(34, 236, 155, 0.06);
        }

        .MatrixTable th:first-of-type,
        .MatrixTable td:first-of-type {
            text-align: left;
        }

        .MatrixTable tbody tr {
            transition: background 0.2s;
        }

        .MatrixTable tbody tr:hover {
            background: rgba(34, 236, 154, 0.12);
        }

        .MatrixTable tbody tr.current-row {
            background: rgba(34, 236, 154, 0.18);
        }

        .MatrixTable tbody tr + tr td {
            border-top: 1px solid #f1f5f9;
        }

        .pct-badge {
            display: inline-block;
            padding: 0.2rem 0.55rem;
            background: #eef9f3;
            color: #065f46;
            border-radius: 6px;
            font-weight: 600;
            font-size: 0.82rem;
        }

        .current-row .pct-badge {
            background: #22ec9b;
            color: #053b26;
        }

        .MatrixTable td.money {
            font-variant-numeric: tabular-nums;
            color: #0f172a;
            font-weight: 500;
        }

        .MatrixTable td.residual-cell {
            color: #475569;
            font-size: 0.82rem;
        }

        .MatrixTable td.plazo-cell {
            font-weight: 600;
        }

        .MatrixTable td.plazo-cell.disabled {
            color: #cbd5e1;
            font-weight: 400;
            font-style: italic;
        }

        .MatrixTable td.plazo-cell.capped {
            background: #fff7ed;
            position: relative;
        }

        .MatrixTable td.plazo-cell.capped .capped-badge {
            display: inline-block;
            margin-left: 0.35rem;
            padding: 0.05rem 0.35rem;
            border-radius: 999px;
            background: #fdba74;
            color: #7c2d12;
            font-size: 0.62rem;
            font-weight: 700;
            line-height: 1.1;
            vertical-align: middle;
        }

        .MatrixFooter {
            margin-top: 0.75rem;
            font-size: 0.78rem;
            color: #64748b;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }

        .MatrixFooter .LegendRow {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 0.35rem;
        }

        .MatrixFooter .MatrixDisclaimer {
            font-size: 0.72rem;
            color: #94a3b8;
            font-style: italic;
            line-height: 1.35;
        }

        .LegendDot {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 3px;
            vertical-align: middle;
            margin-right: 0.3rem;
        }

        .LegendDot.current {
            background: #22ec9b;
        }

        .LegendDot.disabled {
            background: #e2e8f0;
        }

        .LegendDot.capped {
            background: #fdba74;
        }

        .LegendSep {
            opacity: 0.5;
        }

        .InitialTableWrapper {
            border-radius: 14px;
            border: 1px solid #eef2f7;
            overflow: hidden;
            background: #ffffff;
        }

        .InitialPayment--expanded .InitialTableWrapper {
            overflow-x: auto;
        }

        .InitialPayment--expanded .InitialTable {
            min-width: 640px;
        }

        .InitialTable thead th.plazo-col-head {
            text-align: center;
            color: #0f172a;
            font-size: 0.82rem;
            border-left: 1px solid #e2e8f0;
        }

        .InitialTable thead th.plazo-col-head.current-col {
            color: #0e7490;
            background: #ecfeff;
        }

        .InitialTable thead th.sub-head {
            font-size: 0.72rem;
            border-left: 1px solid #e2e8f0;
        }

        .InitialTable {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.88rem;
        }

        .InitialTable th,
        .InitialTable td {
            padding: 0.65rem 0.9rem;
            text-align: right;
        }

        .InitialTable th.money,
        .InitialTable td.money {
            font-variant-numeric: tabular-nums;
        }

        .InitialTable thead th {
            background: #f8fafc;
            color: #64748b;
            font-weight: 600;
            font-size: 0.78rem;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            border-bottom: 1px solid #e2e8f0;
        }

        .InitialTable thead th.money {
            color: #0e7490;
        }

        .InitialTable td.label-cell {
            text-align: left;
            font-weight: 500;
            color: #334155;
            font-size: 0.82rem;
        }

        .InitialTable tr + tr td {
            border-top: 1px solid #f1f5f9;
        }

        .InitialTable tbody tr:not(.total-row):hover {
            background: #cbd5e1;
        }

        .InitialTable .iva-row td {
            color: #0e7490;
            font-style: italic;
            background: rgba(50, 184, 223, 0.08);
        }

        .InitialTable .total-row {
            background: linear-gradient(135deg, #32B8DF 0%, #0891b2 100%);
        }

        .InitialTable .total-row td {
            color: #fff;
            font-weight: 700;
            font-size: 0.94rem;
            padding-top: 0.8rem;
            padding-bottom: 0.8rem;
        }

        .InitialTable .total-row td.total-label {
            letter-spacing: 0.04em;
        }

        .InitialTable .total-row td.total-amount {
            font-size: 1.05rem;
        }

        .QuoteSummaryBar {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
            gap: 0.75rem;
            margin-bottom: 1.5rem;
        }

        .SummaryItem {
            background: #f8fafc;
            border-radius: 12px;
            padding: 0.85rem 1rem;
            border: 1px solid #eef2f7;
        }

        .SummaryItem .label {
            display: block;
            font-size: 0.72rem;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            margin-bottom: 0.3rem;
        }

        .SummaryItem .value {
            display: block;
            font-size: 1.02rem;
            font-weight: 700;
            color: #0f172a;
            font-variant-numeric: tabular-nums;
        }

        .FloatingQuoteCTA {
            position: fixed;
            bottom: 1.75rem;
            left: 0;
            right: 0;
            margin-inline: auto;
            width: fit-content;
            z-index: 80;
            pointer-events: none;
        }

        .FloatingQuoteCTA > * {
            pointer-events: auto;
        }

        .FloatingCTA-button {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 0.6rem;
            padding: 0.9rem 1.75rem;
            border-radius: 999px;
            border: 0;
            background: linear-gradient(135deg, #22EC9A 0%, #32B8DF 100%);
            color: #0a1929;
            font-size: 1rem;
            font-weight: 800;
            cursor: pointer;
            box-shadow: 0 12px 35px -10px rgba(50, 184, 223, 0.55),
                        0 4px 15px -4px rgba(34, 236, 154, 0.4);
            transition: transform 0.2s, box-shadow 0.2s;
        }

        .FloatingCTA-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 18px 45px -12px rgba(50, 184, 223, 0.65),
                        0 6px 20px -4px rgba(34, 236, 154, 0.5);
        }

        .FloatingCTA-button:active {
            transform: translateY(0);
        }

        .FloatingCTA-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(10, 25, 41, 0.15);
            font-weight: 900;
            font-size: 0.8rem;
            color: #0a1929;
        }

        .FloatingCTA-pulse {
            position: absolute;
            inset: 0;
            border-radius: 999px;
            background: rgba(50, 184, 223, 0.35);
            animation: ctaPulse 2s ease-out infinite;
            pointer-events: none;
        }

        @keyframes ctaPulse {
            0%   { transform: scale(1); opacity: 0.5; }
            70%  { transform: scale(1.25); opacity: 0; }
            100% { transform: scale(1.25); opacity: 0; }
        }

        .DissolveCell span {
            display: inline-block;
        }
    `;
}
